import axios from "axios";

const baseURL = process.env.REACT_APP_DOCUMENTS;

const DocumentsClient = axios.create({
  baseURL,
});

DocumentsClient.interceptors.response.use(
  (res) => res.data,
  (error) => Promise.reject(error)
);

export default DocumentsClient;
